export const copyToClipboard = async (text: string): Promise<boolean> => {
    let success = false;

    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        try {
            await navigator.clipboard.writeText(text);
            success = true;
        } catch (err) {
            console.error("Erro ao copiar o texto: ", err);
        }
    } else {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed"; 
        textArea.style.top = "-9999px"; 
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            const successful = document.execCommand("copy");
            success = successful;
        } catch (err) {
            console.error("Erro ao copiar o texto: ", err);
        }

        document.body.removeChild(textArea);
    }

    return success;
};